"use strict";

const STORAGE_KEY = "api_environment";

export const API_ENVIRONMENTS = {
  staging: {
    label: "Staging",
    baseUrl: "https://api-staging.affordamic.com/api/v1",
  },
  production: {
    label: "Production",
    baseUrl: "https://api.affordamic.com/api/v1",
  },
};

export function getApiEnvironment() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && API_ENVIRONMENTS[stored]) {
    return stored;
  }
  return "staging";
}

export function setApiEnvironment(environment) {
  if (!API_ENVIRONMENTS[environment]) {
    throw new Error(`Invalid API environment: ${environment}`);
  }
  localStorage.setItem(STORAGE_KEY, environment);
}

export function getApiBaseUrl() {
  return API_ENVIRONMENTS[getApiEnvironment()].baseUrl;
}

export function getExamSocketUrl() {
  return getApiBaseUrl().replace(/\/api\/v1\/?$/, "");
}

export function getApiEnvironmentLabel(environment = getApiEnvironment()) {
  return API_ENVIRONMENTS[environment]?.label || "Staging";
}
